export default "__VITE_ASSET__b476a806__"